import Client from '@/hexapla-core/client'
import { Book, Meta } from '@/hexapla-core/domains/resources'
import { Domain } from '@/hexapla-core/domains'

export interface BooksService extends Domain<Book> {
  meta: (apiURL: string, src: string, bookID: number | string) => Promise<Meta>
}

export const index = (apiURL: string): Promise<Book[]> =>
  Client.get<Book[]>(`${apiURL}/api/books`)

export const meta = (apiURL: string, src: string, bookID: number | string): Promise<Meta> =>
  Client.get<Meta>(`${apiURL}/api/books/${bookID}/meta/${src}`)

export const create = (apiURL: string, book: Book): Promise<Book> =>
  Client.post<Book, Book>(`${apiURL}/api/admin/books`, book)

export const show = (apiURL: string, bookID: string | number): Promise<Book> =>
  Client.get<Book>(`${apiURL}/api/books/${bookID}`)

export const update = (apiURL: string, book: Book): Promise<Book> =>
  Client.patch<Book, Book>(`${apiURL}/api/books/${book.id}`, book)

export const destroy = (apiURL: string, bookID: number | string): Promise<void> =>
  Client.destroy<void>(`${apiURL}/api/admin/books/${bookID}`)

export default {
  index,
  meta,
  create,
  update,
  show,
  destroy,
} as BooksService
